import React from 'react';
import { Star } from 'lucide-react';
const comments = [{
  quote: 'Llevo 2 semanas usándolo y ya no me quedo hasta tarde organizando todo. Mis domingos son míos otra vez.',
  name: 'Sofía V.',
  role: 'Primaria, Perú'
}, {
  quote: 'Lo mejor es que ahora tengo una estructura. Ya no salto de una cosa a otra sin orden.',
  name: 'Daniela P.',
  role: 'Secundaria, Argentina'
}, {
  quote: 'Pensé que era otro PDF más… pero esto es un sistema completo. Todo tiene lógica.',
  name: 'Gabriela S.',
  role: 'Primaria, Colombia'
}, {
  quote: 'Mi directora me felicitó por la organización de mis clases y documentos. Todo gracias al MegaPack. ¡No exagero!',
  name: 'Fernanda L.',
  role: 'Inicial, México'
}, {
  quote: 'Soy mamá y docente. Este material me devolvió tiempo con mi familia. Lo recomiendo de corazón.',
  name: 'Claudia M.',
  role: 'Primaria, Ecuador'
}, {
  quote: 'Las sesiones, registros y formatos están mucho mejor organizados de lo que esperaba.',
  name: 'Verónica R.',
  role: 'Secundaria, Chile'
}];
export function TestimonialsPreGuarantee() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-283">
      <div className="max-w-xl mx-auto" data-id="element-284">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-2" data-id="element-285">
          🗣️ Docentes reales, resultados reales
        </h2>
        <p className="text-sm text-gray-500 text-center mb-8" data-id="element-286">
          Esto dicen quienes ya aplican el sistema en su trabajo
        </p>

        <div className="space-y-3" data-id="element-287">
          {comments.map((c, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-4 rounded-xl" data-id="element-288">
              <div className="flex gap-0.5 mb-2" data-id="element-289">
                {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-brand-yellow text-brand-yellow" data-id="element-290" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-2 leading-relaxed" data-id="element-291">
                "{c.quote}"
              </p>
              <div className="flex items-center gap-2" data-id="element-292">
                <div className="w-7 h-7 rounded-full bg-gray-700 flex items-center justify-center text-xs font-bold text-brand-yellow flex-shrink-0" data-id="element-293">
                  {c.name.charAt(0)}
                </div>
                <div data-id="element-294">
                  <p className="font-bold text-white text-xs" data-id="element-295">{c.name}</p>
                  <p className="text-[11px] text-gray-500" data-id="element-296">{c.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}